import { EventFieldGrid } from '@klear/order-event-ui/event-forms/event-field-grid'
import { dateFormatted, type DateDisplayInput } from '@klear/order-event/list-display'
import {
  EventDatePicker,
  EventFileInput,
  EventDocumentList,
  EventTextarea
} from '@klear/order-event-ui/event-shared/event-form-control'

export function ProofOfAcceptanceForm() {
  return (
    <>
      <EventFileInput label="Upload File(s)" name="files" multiple />
      <EventDocumentList />
      <EventDatePicker label="Acceptance Date" name="effectiveDate" />
      <EventTextarea label="Notes" name="notes" />
    </>
  )
}

export function ProofOfAcceptanceView({
  proofOfAcceptance
}: {
  proofOfAcceptance: { effectiveDate: DateDisplayInput }
}) {
  return (
    <EventFieldGrid fields={[{ label: 'Acceptance Date', value: dateFormatted(proofOfAcceptance.effectiveDate) }]} />
  )
}
